/**
 * safetyEvents.js
 * Tiny event bus for broadcasting safety state changes from the Axios
 * interceptor to the SafetyBanner component without prop drilling.
 *
 * Usage:
 *   import safetyEvents from './safetyEvents';
 *   safetyEvents.emit('refresh');        // trigger SafetyBanner to re-fetch
 *   safetyEvents.on('refresh', fn);
 *   safetyEvents.off('refresh', fn);
 */
const listeners = {};

const safetyEvents = {
  on(event, fn) {
    if (!listeners[event]) listeners[event] = [];
    listeners[event].push(fn);
  },
  off(event, fn) {
    if (!listeners[event]) return;
    listeners[event] = listeners[event].filter(f => f !== fn);
  },
  emit(event, data) {
    (listeners[event] || []).forEach(fn => fn(data));
  },
};

export default safetyEvents;
